function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 275",
  d: "M68.512 8.598s-.188 1.518-11.842.844S36.746.5 34.87.5s-10.15 8.267-21.8 8.942-11.842-.844-11.842-.844-3.57 35.6 5.263 51.289 28.382 28.679 28.382 28.679 19.549-12.989 28.382-28.679 5.257-51.289 5.257-51.289z",
  fill: "none",
  stroke: "#3c00dc",
  strokeLinejoin: "round"
});

function SvgBadgeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.734,
    height: 89.066,
    viewBox: "0 0 69.734 89.066"
  }, props), _ref);
}

export default SvgBadgeinline;